import { type FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useGetPartnersTaskQuery } from '@/api/queries/user';
import { Picture } from '@/components/ui/Picture/Picture';

import { SocialList } from '../SocialNetworks/Socials/SocialList';

import { PromoCodeForm } from './PromoCodeForm/PromoCodeForm';

import css from './styles.module.scss';

import lightPng from '/img/shop/v2/card-light.png';
import lightWebp from '/img/shop/v2/card-light.webp';
import couponPng from '/img/shop/v2/promo-coupon.png';
import couponWebp from '/img/shop/v2/promo-coupon.webp';

/** "Promo" tab of the shop (Figma "promo banner"). */
const PromoCodeTab: FC = () => {
  const { t } = useTranslation();
  useGetPartnersTaskQuery();

  return (
    <div className="w-full px-4 pt-4 pb-6">
      <article className={css.promoCodeTab}>
        <h1 className={css.title}>{t('Activate promo code and get reward')}</h1>
        <div className={css.coupon}>
          <div className={css.couponGlow} />
          <Picture
            img={lightPng}
            webp={lightWebp}
            alt=""
            className={css.couponLight}
          />
          <div className={css.couponShadow} />
          <Picture
            img={couponPng}
            webp={couponWebp}
            alt="promo code"
            className="relative block size-[120px]"
          />
        </div>
        <PromoCodeForm />
        <p className={css.findText}>
          <Trans
            i18nKey={
              'Find codes on our social networks <br /> and get valuable rewards'
            }
            components={{ br: <br /> }}
          />
        </p>
        <SocialList />
      </article>
    </div>
  );
};

export { PromoCodeTab };
